(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ForgotPasswordViewModel', ForgotPasswordViewModelFactory);

  /** @ngInject */
  function ForgotPasswordViewModelFactory ($translate, applicationStore, $mdToast) {
    function ForgotPasswordViewModel () {
      init.call(this);
    }

    ForgotPasswordViewModel.prototype.destroy = function () {

    };

    return ForgotPasswordViewModel;

    function init () {
      this.hasErrors = false;
			this.errorMsg = $translate.instant('FORGOT_PASSWORD_ERROR_MSG');
      applicationStore.on(applicationStore.events.TOAST_CHANGE, showSimpleToast);
    }

    function showSimpleToast(data) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(data)
          .position('bottom right')
          .hideDelay(3000)
      );
    }

  }
})();
